<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
            d="M26.2977 9.31166C24.6771 17.9036 17.9049 24.6758 9.31296 26.2964C7.1421 26.7058 5.33463 24.8758 5.33463 22.6667V19.6667C5.33463 19.1144 5.78299 18.6706 6.33377 18.6298C7.69159 18.5292 8.99283 18.2253 10.2071 17.7483L12.2328 19.774C15.5276 18.1973 18.1986 15.5263 19.7753 12.2316L17.7496 10.2058C18.2266 8.99154 18.5305 7.6903 18.6311 6.33247C18.6719 5.78169 19.1157 5.33333 19.668 5.33333H22.668C24.8771 5.33333 26.7071 7.1408 26.2977 9.31166Z"
            fill="#7A70DF"/>
        <path d="M13.3344 13.3333L8.00098 7.99991M13.3344 13.3333L13.3343 10.3431M13.3344 13.3333L10.3441 13.3333"
              stroke="#7A70DF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
